import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Member from 'src/entities/Member';

import { createMember, rememberSigninMember } from '../../actions/member';
import Navigation from '../Navigation/global';

interface IProps {
  account: Member;
  token: string;
  createMember: (member: Member) => void;
  rememberSigninMember: (member: Member) => {};
}

interface IState {
  account: Member;
}

class CreateComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      account: new Member()
    };

    this.createMember = this.createMember.bind(this);
  }

  componentWillMount() {
    const member = new Member();
    member.token = this.props.token;
    this.props.rememberSigninMember(member);
  }

  render() {
    if (this.props.account.id !== undefined) {
      return (
        <Redirect
          to={{
            pathname: '/',
            state: { from: location.pathname }
          }}
        />
      );
    }

    return (
      <div id="AccountCreate">
        <Navigation isLogoOnly={true} isVisiter={true} />

        <div id="Content">
          <div id="CreateTitle">新規登録</div>

          <div className="ContentItem">
            <label>従業員コード</label>
            <input
              className="InputText"
              value={this.state.account.id}
              onChange={this.onChangeItem.bind(this, 'id')}
            />
          </div>

          <div className="ContentItem">
            <label>電話番号</label>
            <input
              className="InputText"
              value={this.state.account.phone}
              onChange={this.onChangeItem.bind(this, 'phone')}
            />
          </div>

          <div className="ContentItem">
            <label>姓</label>
            <input
              className="InputText"
              value={this.state.account.nameLast}
              onChange={this.onChangeItem.bind(this, 'nameLast')}
            />
          </div>

          <div className="ContentItem">
            <label>名</label>
            <input
              className="InputText"
              value={this.state.account.nameFirst}
              onChange={this.onChangeItem.bind(this, 'nameFirst')}
            />
          </div>

          <div className="ContentItem">
            <label>パスワード</label>
            <input
              className="InputText"
              value={this.state.account.password}
              onChange={this.onChangeItem.bind(this, 'password')}
            />
          </div>

          <button onMouseUp={this.createMember} onTouchEnd={this.createMember}>
            登録
          </button>
        </div>
      </div>
    );
  }

  createMember(e: any) {
    const account = Object.assign({}, this.state.account);
    account.token = this.props.token;
    this.props.createMember(account);
  }

  onChangeItem(item: string, e: any) {
    const account = Object.assign({}, this.state.account);

    if (item === 'id') {
      account.id = Number(e.target.value);
    } else if (item === 'phone') {
      account.phone = e.target.value;
    } else if (item === 'nameLast') {
      account.nameLast = e.target.value;
    } else if (item === 'nameFirst') {
      account.nameFirst = e.target.value;
    } else if (item === 'password') {
      account.password = e.target.value;
    }

    this.setState({
      account
    });
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  account: state.Account,
  token: ownProps.match.params.token
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    createMember(member: Member) {
      dispatch(createMember(member));
    },
    rememberSigninMember(member: Member) {
      dispatch(rememberSigninMember(member));
    }
  };
};

const Memo = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateComponent);

export default Memo;



// WEBPACK FOOTER //
// ./src/components/Account/create.tsx